import React from 'react';

import Tooltip from 'ui-library/floating-ui/Tooltip';

interface KeyValueBodyProps {
  keyText: string;
  valueText: string;
}

interface KeyValueTooltipProps extends KeyValueBodyProps {
  children: JSX.Element;
}

const KeyValueBody = ({keyText, valueText}: {keyText: string; valueText: string}): JSX.Element => (
  <div>
    <strong>{keyText}</strong>
    <br />
    <span>{valueText}</span>
  </div>
);

const KeyValueTooltip = ({children, keyText, valueText}: KeyValueTooltipProps): JSX.Element => (
  <Tooltip text={<KeyValueBody keyText={keyText} valueText={valueText} />}>{children}</Tooltip>
);

export default KeyValueTooltip;
